import { render, staticRenderFns } from "./PriceFormulaInput.vue?vue&type=template&id=87da0b9a&"
import script from "./PriceFormulaInput.vue?vue&type=script&lang=js&"
export * from "./PriceFormulaInput.vue?vue&type=script&lang=js&"
import style0 from "./PriceFormulaInput.vue?vue&type=style&index=0&id=87da0b9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports